export const GOOGLE_CONFIG = {
    CLIENT_ID: '691423973656-a0e4aj8bkkqrqap3fln0roa7ij1s91cc.apps.googleusercontent.com',
    REDIRECT_URI: 'com.googleusercontent.apps.691423973656-a0e4aj8bkkqrqap3fln0roa7ij1s91cc:/auth',
};
